import { trackInternalEvent } from '@rio/tracking'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { useFeaturesConfig } from 'builder/hooks/featureConfig/useFeaturesConfig'

import { Service } from '../../../types'
import { useFirst90DaysPlanActions } from './hooks/useFirst90DaysPlanActions'
import { First90DaysPlanInfo, Steps } from './hooks/useFirst90DaysPlanConfig'
import * as Styles from './styles'

type ActionButtonsProps = {
  status: 'initial' | 'progress' | 'completed'
  text: First90DaysPlanInfo
  steps: Steps
  service: Service
  handleCloseModal: () => void
}

export const ActionButtons = ({
  text,
  status,
  steps,
  service,
  handleCloseModal,
}: ActionButtonsProps) => {
  const { isPhone } = useMediaQueries()
  const { features } = useFeaturesConfig()
  const { handleOpen90DaysPage, handleOpenBookCoach } = useFirst90DaysPlanActions()

  const open90DaysPage = () => {
    trackInternalEvent('progress_cta_click', {
      score: service.title,
      cta: text.actions.see_plan,
    })
    handleOpen90DaysPage()
  }

  const openBookCoach = (isModal?: boolean) => {
    if (isModal) {
      trackInternalEvent('progress_promo', { type: 'coaching' })
      trackInternalEvent('progress_promo_cta_click', {
        type: 'coaching',
        cta: text.book_coach,
      })
      handleCloseModal()
    } else {
      trackInternalEvent('progress_cta_click', {
        score: service.title,
        cta: text.actions.book_coach,
      })
    }
    handleOpenBookCoach()
  }

  const showScore = (completed?: boolean, score?: number) => {
    if (isPhone) return null
    if (completed) {
      return (
        <Styles.IconContainer>
          <Styles.Icon />
        </Styles.IconContainer>
      )
    }
    return <Styles.ScoreText>+{score}%</Styles.ScoreText>
  }

  if (status === 'initial') {
    return (
      <Styles.InitialActionButtonsContainer>
        <Styles.InitialContinueButton onClick={() => openBookCoach(true)}>
          {text.book_coach}
        </Styles.InitialContinueButton>
        <Styles.InitialCloseButton onClick={handleCloseModal}>
          {text.close_modal}
        </Styles.InitialCloseButton>
      </Styles.InitialActionButtonsContainer>
    )
  }

  return (
    <Styles.ProgressActionButtonsContainer>
      <Styles.ButtonContainer onClick={open90DaysPage}>
        <Styles.ActionText>{text.actions.see_plan}</Styles.ActionText>
        {showScore(steps.page_seen?.completed, steps.page_seen?.target_score)}
      </Styles.ButtonContainer>
      {features.careerCoaching && (
        <Styles.ButtonContainer onClick={() => openBookCoach(false)}>
          <Styles.ActionText>{text.actions.book_coach}</Styles.ActionText>
          {showScore(
            !steps.page_seen?.completed || steps.career_coaching?.completed,
            steps.career_coaching?.target_score,
          )}
        </Styles.ButtonContainer>
      )}
    </Styles.ProgressActionButtonsContainer>
  )
}
